import { combineReducers } from 'redux';

import basicState, { basicInitialState } from './basic';
import copyModalState, { copyModalInitialState } from './copyModal';

export const listInitialState =  {
  basicState: basicInitialState,
  copyModalState: copyModalInitialState,
}

export default combineReducers({
  basicState,
  copyModalState
})